import ServiceRegistry from '@/service/registry/ServiceRegistry'

export const INJECTED_SERVICE_PROVIDER = 'INJECTED_SERVICE_PROVIDER'

/**
 * This is a temp Vuex getter that allows for temporary patching of
 * Vuex store methods and Service injection cross over. Using the
 * injection functionality of the SessionRegistry to provide the
 * singleton service instance. This is defined as a getter to allow
 * all Vuex functions to access if needed
 * @example
 * const notificationService = getters[INJECTED_SERVICE_PROVIDER](NotificationService)
 */
const getters = {
  [INJECTED_SERVICE_PROVIDER]: () => (service) => {
    return ServiceRegistry.inject(service)
  }
}

export default { state: {}, getters, actions: {}, mutations: {} }
